import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import { useEffect, useState } from "react";
import { useDebounce } from "ahooks";
import { Button } from "../../components";
import Icon from "../../icons";
import Input from "../Input/Input";
const InputSearch = React.forwardRef(({ debounceInMillis = 300, placeholder, onChange, ...props }, ref) => {
    const [value, setValue] = useState();
    const debouncedValue = useDebounce(value, { wait: debounceInMillis });
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const handleClear = () => {
        setValue("");
    };
    useEffect(() => {
        if (debouncedValue !== undefined)
            onChange(debouncedValue);
    }, [debouncedValue, onChange]);
    // Clear value when props.value is undefined or empty - ex: when clear button outside is clicked
    useEffect(() => {
        if (props.value === undefined || props.value === "")
            setValue("");
    }, [props.value]);
    return (_jsx(Input, { ...props, ref: ref, startIcon: _jsx(Icon, { name: "search" }), placeholder: placeholder || "Procurar...", endIcon: value ? _jsx(Button, { "data-testid": "clear-search", variant: "ghost", color: "default", icon: _jsx(Icon, { name: "x", className: "text-gray-12" }), onClick: handleClear }) : null, value: value || props.value, onChange: handleChange }));
});
InputSearch.displayName = "InputSearch";
// Important: This is a memoized component to prevent unnecessary re-renders.
export default memo(InputSearch, (prevProps, nextProps) => {
    return prevProps.value === nextProps.value;
});
